const makeRequestType = function (eventType: string) {
  return eventType + '_REQUEST';
};

const makeResponseType = function (eventType: string) {
  return eventType + '_RESPONSE';
};

const makeRequestEvent = function (
  eventType: string,
  payload: any = undefined,
) {
  const request = {
    eventType: eventType,
    data: payload == undefined || payload === '' ? '' : payload,
  };
  return JSON.stringify(request);
};

const eventProvider = {
  makeRequestType: makeRequestType,
  makeResponseType: makeResponseType,
  makeRequestEvent: makeRequestEvent,
};

export default eventProvider;
